import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'
import React from 'react'

import WarningIcon from '@mui/icons-material/Warning'

interface ListItemWarningProps {
  primary: string,
  secondary: string
}

export const ListItemWarning: React.FC<ListItemWarningProps> = ({
  primary,
  secondary
}) => {
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar>
          <WarningIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItem>
  )
}
